"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var utils_1 = require("@doshexchnage/utils");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../../../constants/routes");
var constants_1 = require("../../../constants");
function useRenderCellViews() {
    var renderCellViews = (0, react_3.useCallback)(function (event) {
        var _a;
        return [
            { key: "at", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: (0, utils_1.formatDateTime)(new Date(event.at)) }) },
            {
                key: "segment_name",
                content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.SEGMENTS_ROUTE, "/").concat(event.segment_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: event.segment_name || event.segment_id })),
            },
            {
                key: "display_name",
                content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CUSTOMERS_ROUTE, "/").concat(event.user_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: event.display_name || event.user_id })),
            },
            {
                key: "kind",
                content: ((0, jsx_runtime_1.jsxs)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", color: event.kind === "entered" ? "success" : "danger", children: [(0, jsx_runtime_1.jsx)(react_2.Icon, { icon: event.kind === "entered" ? "solar:login-2-linear" : "solar:logout-2-linear", width: 14 }), (_a = constants_1.triggerLabels[event.kind]) !== null && _a !== void 0 ? _a : event.kind] })),
            },
            { key: "stint", content: (0, jsx_runtime_1.jsxs)("div", { className: "text-sm text-muted", children: ["#", event.stint] }) },
            { key: "reason", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: (0, constants_1.membershipReasonLabel)(event.reason) }) },
            {
                key: "silent",
                content: event.silent ? ((0, jsx_runtime_1.jsx)(react_1.Chip, { className: "text-nowrap", size: "sm", variant: "soft", children: "Skipped" })) : null,
            },
        ];
    }, []);
    return (0, react_3.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
